
import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Expense } from "@/hooks/useHouseExpenses";

interface ExpenseItemSelectionProps {
  expenses: Expense[];
  selectedExpenses: Set<string>;
  onExpenseToggle: (expenseId: string) => void;
}

export const ExpenseItemSelection = ({
  expenses,
  selectedExpenses,
  onExpenseToggle,
}: ExpenseItemSelectionProps) => {
  if (expenses.length === 0) {
    return <p className="text-muted-foreground">No hay gastos registrados para este periodo</p>;
  }

  return (
    <div className="space-y-3 max-h-[300px] overflow-y-auto pr-2">
      {expenses.map(expense => (
        <div key={expense.id} className="flex items-start space-x-3 p-3 border rounded-md">
          <Checkbox
            id={`expense-${expense.id}`}
            checked={selectedExpenses.has(expense.id)}
            onCheckedChange={() => onExpenseToggle(expense.id)}
          />
          <div className="grid gap-1.5 leading-none w-full">
            <Label
              htmlFor={`expense-${expense.id}`}
              className="text-sm font-medium cursor-pointer flex justify-between w-full"
            >
              <span>{expense.expense_categories.name}</span>
              <span className="font-semibold">
                ${expense.amount.toLocaleString('es-CL')}
              </span>
            </Label>
            {expense.description && (
              <p className="text-xs text-muted-foreground">
                {expense.description}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
